export const EMOTION_PALETTES = [
  {
    emotion: "Trust & Security",
    primary: "#0F4C81",
    palette: ["#0F4C81", "#1B365D", "#536878", "#A3C1AD"],
    description: "Deep blues that evoke stability and professional reliability."
  },
  {
    emotion: "High Energy",
    primary: "#FF4500",
    palette: ["#FF4500", "#FF8C00", "#FFD700", "#8B0000"],
    description: "Vibrant oranges and reds designed to drive action and excitement."
  },
  {
    emotion: "Luxury & Sophistication",
    primary: "#1A1A1A",
    palette: ["#1A1A1A", "#333333", "#C0C0C0", "#CFB53B"],
    description: "Monochromatic tones paired with metallic accents for premium feel."
  },
  {
    emotion: "Growth & Wellness",
    primary: "#2E8B57",
    palette: ["#2E8B57", "#3CB371", "#8FBC8F", "#F0FFF0"],
    description: "Natural greens that promote health, peace, and prosperity."
  },
  {
    emotion: "Innovation & Tech",
    primary: "#00F2FF",
    palette: ["#00F2FF", "#007BFF", "#6F42C1", "#E83E8C"],
    description: "Cyber neons and gradients representing the digital frontier."
  }
];

export const POPULAR_SWATCHES = [
  { hex: "#3B82F6", name: "Digital Blue" },
  { hex: "#EF4444", name: "Signal Red" },
  { hex: "#10B981", name: "Success Green" },
  { hex: "#F59E0B", name: "Warning Amber" },
  { hex: "#6366F1", name: "Indigo Modern" },
  { hex: "#EC4899", name: "Playful Pink" },
  { hex: "#8B5CF6", name: "Royal Violet" },
  { hex: "#111827", name: "Midnight" },
  { hex: "#F97316", name: "Hot Orange" },
  { hex: "#06B6D4", name: "Ocean Teal" },
  { hex: "#84CC16", name: "Lime Energy" },
  { hex: "#64748B", name: "Slate Corporate" }
];

export const INDUSTRY_GUIDE = [
  {
    category: "Tech & SaaS",
    colors: ["#3B82F6", "#0F172A", "#6366F1"],
    logic: "Focus on trust, logic, and modern interface clarity."
  },
  {
    category: "Luxury & Fashion",
    colors: ["#000000", "#D4AF37", "#FFFFFF"],
    logic: "High contrast and metallic accents for exclusivity."
  },
  {
    category: "Food & Beverage",
    colors: ["#E11D48", "#F59E0B", "#166534"],
    logic: "Warm tones stimulate appetite; greens suggest freshness."
  },
  {
    category: "Healthcare",
    colors: ["#0EA5E9", "#10B981", "#F8FAFC"],
    logic: "Clean, sterile, and calming palettes to reduce anxiety."
  }
];

export const RAINBOW_COLORS = [
  { name: "Ruby", hex: "#E11D48" },
  { name: "Amber", hex: "#F59E0B" },
  { name: "Citrus", hex: "#EAB308" },
  { name: "Emerald", hex: "#10B981" },
  { name: "Azure", hex: "#3B82F6" },
  { name: "Indigo", hex: "#6366F1" },
  { name: "Violet", hex: "#A855F7" }
];

export const COLOR_OF_THE_MONTH = {
  month: "February 2025",
  name: "Frost Amethyst",
  hex: "#9333EA",
  meaning: "Creativity, transformation, and digital innovation in the new year.",
  inspiration: "Perfect for creative agencies, AI/tech startups, and brands positioning themselves as forward-thinking visionaries. Purple balances trust (blue) with passion (red)—but only if you can back it up with actual innovation.",
  tags: ["Innovative", "Creative", "Premium", "Visionary"]
};